<template>
    <div>
        <general-dialog :dialog.sync="recordDialog" :header="header">
            <template #content>
                <v-combobox
                    v-model="selectedStatus"
                    :items="recordStatuses"
                    item-text="name"
                    item-value="value"
                    label="Status of this record"
                />
            </template>
            <template #action>
                <v-btn color="agrinome_primary" class="v-btn-bold-color" dark @click="confimrUpdateStatus($event)">UDPATE</v-btn>
            </template>
        </general-dialog>
    </div>
</template>

<script>
export default {
    name: "RecordStatusDialog",
    props: [ "TableId", "ApiInfo", "updateMultiple", "dialog", "StatusInfo" ],
    data() {
        return {
            recordDialog: false,
            header: "Update the Status",

            recordStatuses: [
                { name: "OK", value: "OK" },
                { name: "R", value: "R" },
                { name: "KIV", value: "KIV" },
                { name: "-", value: null }
            ],
            selectedStatus: "OK",
            isUpdateMultiple: false,
        };
    },
    watch: {
        recordDialog() {
            if (this.recordDialog == false) {
                this.$emit("update:dialog", false);
            }
        },
        dialog() {
            this.recordDialog = this.dialog;
        },
        updateMultiple() {
            this.isUpdateMultiple = this.updateMultiple;
        },
        StatusInfo: {
            handler(val) {
                this.selectedStatus = this.StatusInfo.SelectedStatus ;
                this.StatusId = this.StatusInfo.StatusId ;
                this.isUpdateMultiple = this.StatusInfo.UpdateMultiple ;
                this.recordDialog = this.StatusInfo.Dialog ;
            },
            deep: true
        }
    },
    methods: {
        confimrUpdateStatus() {
            if (this.isUpdateMultiple) this.updateMultipleRecordStatus();
            else this.updateSingleRecordStatus();
        },
        updateSingleRecordStatus() {
            var self = this;
            this.$nextTick(function() {
                axios({
                    method: "PUT",
                    url: `${this.ApiInfo.Table}/UpdateStatus`,
                    data: {
                        Id: self.StatusId,
                        status: self.selectedStatus.value
                    }
                })
                    .then(function (response) {
                        EventBus.$emit("snackBar", {
                            text: "Status Updated",
                            snackbarColor: "green darken-2"
                        });
						
                        self.$emit("updated-success");
                        self.reloadTable(self.TableId);
                        self.recordDialog = false;
                    });
            });
        },
        updateMultipleRecordStatus() {
            var self = this;
            var data_lists = [];
            data_lists = this.$store.state.selectionRow.map(row => ({
                id: row.id,
                status: self.selectedStatus.value
            }));

            var dataObj = {};
            dataObj[this.ApiInfo.UpdateManyKey] = data_lists;
				
            axios({
                method: "PUT",
                url: `${this.ApiInfo.Table}/UpdateManyStatus`,
                data: dataObj
            }).then(function (response) {
                EventBus.$emit("snackBar", {
                    text: "Records Status Updated",
                    snackbarColor: "green darken-2"
                });
                self.$store.commit("updateAgrinomeTableState", true);
                self.recordDialog = false;
            });
        },
    },
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/smallComponents/RecordStatusDialog.vue